import { Component, OnInit, ViewChild } from '@angular/core';
import { MdbTableDirective, MdbTablePaginationComponent } from 'angular-bootstrap-md';
import { LocalesModule } from '../../modelo/locales/locales.module';
import { ventaLocalModule } from '../../modelo/usuario/ventaLocal';
import { LoginService } from '../../servicios/login.service';
import { ReporteService } from '../../servicios/reporte.service';
import { ReportVentasxLocalComponent } from '../report-ventasx-local/report-ventasx-local.component';

@Component({
  selector: 'app-report-rakingx-local',
  templateUrl: './report-rakingx-local.component.html',
  styleUrls: ['./report-rakingx-local.component.css']
})
export class ReportRakingxLocalComponent implements OnInit {
  alertService: any;
  anios: [];
  tipo: [];
  meses: [];
  mesesMostrar: [];
  aniosselect:string[]
  anioselec: string;
  local:string;
  categoria: string;
  meseSelec: string[];
  datosVentas: ventaLocalModule[];
  datosDevolucion: ventaLocalModule[];
  totalventa:number;
  totaldevolucion:number;
  listaLocales:LocalesModule[];
  habilitar:boolean;
  id_pais:string;
  tipoSelec: [];
  usuario:string;
   id:string;
  mesesAnio = [
    { id: 1, name: 'Enero' },
    { id: 2, name: 'Febrero' },
    { id: 3, name: 'Marzo' },
    { id: 4, name: 'Abril' },
    { id: 5, name: 'Mayo' },
    { id: 6, name: 'Junio' },
    { id: 7, name: 'Julio' },
    { id: 8, name: 'Agosto' },
    { id: 9, name: 'Septiembre' },
    { id: 10, name: 'Octubre' },
    { id: 11, name: 'Noviembre' },
    { id: 12, name: 'Diciembre' },
  ];
  @ViewChild(MdbTablePaginationComponent) mdbTablePagination: MdbTablePaginationComponent;
  @ViewChild(MdbTableDirective) mdbTable: MdbTableDirective;

  @ViewChild(MdbTablePaginationComponent) mdbTablePaginationD: MdbTablePaginationComponent;
  @ViewChild(MdbTableDirective) mdbTableD: MdbTableDirective;

  constructor(private api: ReporteService,private apiLogin: LoginService) { }

  ngOnInit(): void {
    this.id_pais=localStorage.getItem("id_pais");
    this.tipoSelec = [];
    this.meseSelec=[];
  this.aniosselect=[];
    this.listarAnioxLocal();
    this.listartipoCliente();
    this.local=localStorage.getItem("nombreLocal");
    //this.listarLocales();

  }



  onChangeLocal($event: Event) {
  
    localStorage.setItem('id', this.id);
    this.listaLocales.forEach(item => {
      if (item.id.toString() ==this.id){
        localStorage.setItem('nombreLocal', item.Nombre_ClientesFinales);  
        this.usuario=localStorage.getItem('nombre');
      this.local=localStorage.getItem('nombreLocal');
      this.id_pais=localStorage.getItem("id_pais");
      this.tipoSelec = [];
      this.meseSelec=[];
    this.aniosselect=[];
      this.listarAnioxLocal();
      this.listartipoCliente();
      this.local=localStorage.getItem("nombreLocal");
    
  

      }
      
    });
   
    }

  public  listarLocales(){
    this.apiLogin.locales(localStorage.getItem("id_pais"))
    .subscribe((
      data: LocalesModule[]) => {
      this.listaLocales = data;
      this.usuario=localStorage.getItem("nombre");
      this.local=localStorage.getItem("nombreLocal");
      this.id=localStorage.getItem("local");
      if (localStorage.getItem("rol")=='MaxiPan' || localStorage.getItem("rol")=='Gerencia CF' )
    {     this.habilitar=false;
    }else{
     this.habilitar=true;
    }
     console.log(this.listaLocales);
     this.listaLocales.forEach(item => {
      if (item.id.toString() ==this.id){
        localStorage.setItem('nombreLocal', item.Nombre_ClientesFinales);  
      }
      
    });
    },
   // err =>  this.alertService.danger('Error no hay  conexion..')
    );
  }
  listarVenta() {
    let meses = "";
    let ani="";
    let tipoDatos = "";
    let productos = "";
    this.meseSelec.forEach(element => {
      meses = meses + element + ",";
    });

    this.aniosselect.forEach(element => {
      ani = ani + element + ",";
    });
    if (this.tipoSelec.length>0){
    this.tipoSelec.forEach(element => {
      tipoDatos = tipoDatos + "'"+element + "',";
    });
  }else{
    tipoDatos = "'"+ localStorage.getItem("tipoLocal") + "',";
  }


    if (meses.length > 0) {
      meses = meses + '0';
    } else {
      meses = "''"
    }


    if (ani.length > 0) {
      ani = ani + '0';
    } else {
      ani = "NO"
    }

    if (tipoDatos.length > 0) {
      tipoDatos = tipoDatos + "'0'"
    } else {
      tipoDatos = "''"
    }
    this.totalventa=0;
    this.api.rankinLocalVenta(ani, meses, tipoDatos,this.id_pais).subscribe((
      data: []) => {
      this.datosVentas = data;
      this.totalventa=0;
      this.datosVentas.forEach(element => {
     
          this.totalventa=this.totalventa+
          Number.parseFloat(element.venta.toString());
      
        });
      this.mdbTable.setDataSource(this.datosVentas);
      this.mdbTable.dataSourceChange();
      this.listarDevolucion();
    },
      err => this.alertService.danger('Error no hay  conexion..')
    );
  }



  listarDevolucion() {
    let meses = "";
    let ani="";
    let tipoDatos = "";
    let productos = "";
    this.meseSelec.forEach(element => {
      meses = meses + element + ",";
    });

    this.aniosselect.forEach(element => {
      ani = ani + element + ",";
    });
if (  this.tipoSelec.length>0){
    this.tipoSelec.forEach(element => {
      tipoDatos = tipoDatos + "'"+element + "',";
    });
}else{
    tipoDatos = "'"+ localStorage.getItem("tipoLocal") + "',";
  }

    if (meses.length > 0) {
      meses = meses + '0';
    } else {
      meses = "''"
    }
    if (ani.length > 0) {
      ani = ani + '0';
    } else {
      ani = "NO"
    }


    if (tipoDatos.length > 0) {
      tipoDatos = tipoDatos + "'0'"
    } else {
      tipoDatos = "''"
    }
    this.totaldevolucion=0;
    this.api.rankinLocalDevolucion(ani, meses, tipoDatos,this.id_pais).subscribe((
      data: []) => {
      this.datosDevolucion = data;
      this.datosDevolucion.forEach(element => {
        let porcentaje= Number.parseFloat(
          element.devolucion.toString());
          let valor=Math.round((porcentaje + Number.EPSILON) * 100) /100 
        if (valor>=0 && valor<10){
          element.color="white"
        }
        if (valor>=10 && valor<15){
         element.color="yellow"
       }
       if (valor>=15 && valor<30){
         element.color="orange"
       }
       if (valor>=30){
         element.color="red"
       }


        this.totaldevolucion=this.totaldevolucion+Number.parseFloat(
          element.devolucion.toString()
        )
      });
      this.mdbTableD.setDataSource(this.datosDevolucion);
      this.mdbTableD.dataSourceChange();
    },
      err => this.alertService.danger('Error no hay  conexion..')
    );
  }



fieldsChange(ev): void {

  if(ev.target.checked){
    this.aniosselect.push(ev.target.defaultValue);
     }else{
       const index: number =this.aniosselect.indexOf(ev.target.defaultValue);
       if (index !== -1) {
         this.aniosselect.splice(index, 1);
      
     }  
     }
    // this.listarVenta();
    // this.listarDevolucion();
     this.listarMesesVendidos(ev.target.defaultValue)
    
  } 

fieldsChangeTipoCliente(ev): void {

  if(ev.target.checked){
  this.tipoSelec.push(ev.target.defaultValue as never)
  //this.listarVenta();
  //this.listarDevolucion();
}else {
  const index: number = this.tipoSelec.indexOf(ev.target.defaultValue as never);
  if (index !== -1) {
    this.tipoSelec.splice(index, 1);

  }
 // this.listarVenta();
 // this.listarDevolucion();

}
}

buscar(){
  this.listarVenta();
  this.listarDevolucion();
 
}

fieldsChangeMes(ev): void {

  if(ev.target.checked){
  this.meseSelec.push(ev.target.defaultValue);
  //this.listarVenta();
  //this.listarDevolucion();
}else {
  const index: number = this.meseSelec.indexOf(ev.target.defaultValue);
  if (index !== -1) {
    this.meseSelec.splice(index, 1);

  }
 // this.listarVenta();
 // this.listarDevolucion();
}

//  this.ventaPorLocal();
console.log(this.meseSelec);
  }

listarMesesVendidos(anio: string){
  this.mesesMostrar = [];
  this.mesesAnio.forEach(element => {
      this.mesesMostrar.push(element as never);
   });
/*
  this.api.meses(localStorage.getItem("nombreLocal"), anio).subscribe((
    data: []) => {
    this.meses = data;
    this.meses.forEach(mes => {
      

    });

  },
    err => this.alertService.danger('Error no hay  conexion..')
  );
  */
  console.log(this.mesesMostrar);
}


listarAnioxLocal(){
  this.api.anios(localStorage.getItem("nombreLocal"),this.id_pais).subscribe((
    data: []) => {
    this.anios = data;
    console.log(this.anios);
    //this.listarVenta();
    //this.listarDevolucion();
  },
    err => this.alertService.danger('Error no hay  conexion..')
  );
}

listartipoCliente(){
let tipoLocal= localStorage.getItem("tipoLocal")
if (tipoLocal=="SN"){
  this.api.tipoCliente(this.id_pais).subscribe((
    data: []) => {
    this.tipo = data;
    console.log(this.tipo);
  },
    err => this.alertService.danger('Error no hay  conexion..')
  );
}else{

}

}
      


}
